
import React, { useEffect, useState } from 'react';
import { Box, Card, Divider, TableBody, Typography, ListItemText } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';
import Paginator from "../../../toolkit/Paginator";
import { debounce } from 'lodash';
import axios from '../../../utils/fvAxios';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
//import Nodata from "../../../Nodata/Nodata";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import IconButton from '@mui/material/IconButton';
import OutsideNetworkEmailPage from './OutsideNetworkEmailPage';
import SwipeableDrawer from "@mui/material/SwipeableDrawer";

//import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import apiinfo from "../../../utils/base-uri.json";
import CloseIcon from '@mui/icons-material/Close';
import FormControl from "../../../components/FormControl";

export default function OutsideNetwork() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.action.hover,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
            marginBottom: "20px"
        },
    }));
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: "320px",
            },

        },
    };
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [dialogopen, setDialogOpen] = React.useState(false);

    const [spinner, setSpinner] = React.useState(false);
    const [statusList, setStatusList] = React.useState([]);
    const [clientList, setClientList] = React.useState([]);
    const [VendorsForInviteList, setVendorsForInviteList] = React.useState([]);
    const [clientId, setClientId] = React.useState("");

    const [states, setStates] = useState([]);
    const [countries, setCountries] = useState([]);
    const [BiddingIntrestsList, setBiddingIntrestsList] = React.useState([]);
    const [ClaycoBiddingIntrestsList, setClaycoBiddingIntrestsList] = React.useState([]);
    const [ClientProfiencyCapabilitiesList, setClientProfiencyCapabilitiesList] = React.useState([]);
    const [ClientProfiencyCapabilitiesListIds, setClientProfiencyCapabilitiesListIds] = React.useState([]);
    //const [ClientProfiencyCapabilitiesIds, setClientProfiencyCapabilitiesIds] = React.useState([]);

    const [Checked, setChecked] = React.useState(false);
    const [Count, setCount] = useState("");
    const [number, setNumber] = useState("1");
    const [state, setState] = React.useState(false);
    const [Info, setInfo] = useState({});

    const [To, setTo] = useState("");
    const [Body, setBody] = useState("");
    const [VendorSummary, setVendorSummary] = useState("");
    const [CCandBCCInfo, setCCandBCCInfo] = useState([]);
    const [LocationsList, setLocationsList] = React.useState([]);
    const [RisklevelList, setRisklevelList] = React.useState([]);
    const [VendorTypeList, setVendorTypeList] = React.useState([]);

    const [BiddingIntrestsListIds, setBiddingIntrestsListIds] = React.useState([]);
    const [ClaycoBiddingIntrestsListIds, setClaycoBiddingIntrestsListIds] = React.useState([]);
    const [counrtyid, setCounrtyid] = useState("");
    const [stateid, setStateid] = useState("");
    const [City, setCity] = useState("");
    const [Search, setSearch] = useState("");
    const [Searchdebounce, setSearchdebounce] = useState("");
    const [Save, setSave] = React.useState(false);
    const [MultiClient, setMultiClient] = React.useState("");

    const DialogOpenClick = async (r) => {
        setSpinner(true);
        setInfo(r);
        const re = await axios.get("MyAccount/GetCCAndBCCListForEmailVendor?orgID=" + clientId);
        setCCandBCCInfo(re?.data?.data);

        axios.get("Common/GetLocationsByClientId?clientId=" + clientId)
            .then((res) => {
                setLocationsList(res?.data?.data);
            }).catch(err => {
                console.log(err);
            })
        const resp = await axios.get("Common/GetRiskLevelWithDetailsByClientId?clientId=" + clientId);
        setRisklevelList(resp?.data?.data);

        axios.get("AdminVendors/GetInvitationTemplateAndToEmail?clientId=" + clientId + "&vendorId=" + r?.orgId)
            .then((resp) => {
                setBody(resp?.data?.data?.item1);
                setTo(resp?.data?.data?.item2);
            }).catch(err => {
                console.log(err);
            })
        axios.get("AdminVendors/GetVendorSummaryForOutsideNetwork?clientId=" + clientId + "&vendorId=" + r?.orgId)
            .then((respo) => {
                setVendorSummary(respo?.data?.data);
            }).catch(err => {
                console.log(err);
            })

        axios.post("/Client/GetClientContractTypes?clientId=" + clientId)
            .then((responce) => {
                setVendorTypeList(responce?.data?.data?.item2);
            }).catch(err => {
                console.log(err);
            })

        setDialogOpen(true);
        setSpinner(spinner);

    };
    const DialogCloseClick = () => {
        setDialogOpen(false);

    };

    const getState = (e) => {
        setCounrtyid(e);
        const NewOne = e == "Any" ? "" : e;
        axios.get("Companies/GetStateSelectListItems?includeCanada=false&showIDs=false&ClientId?clientID=" + 0 + "&country=" + NewOne)
            .then((res) => {
                setStates(res?.data?.data);
            }).catch(err => {
                console.log(err)
            })
    }
    // const ChangeState = (e) => {
    //     setStateid(e);
    // }

    useEffect(() => {
        Details();
    }, []);

    async function Details() {
        const res = await axios.get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false");
        setClientList(res?.data?.data);
        setClientId(res?.data?.data[0]?.value);

        axios.get(apiinfo.addressInfo.getCountries)
            .then((res) => {
                let Country = res?.data?.data;
                if (res?.data?.data) {
                    Country?.unshift({ key: "Any", value: "Any" });
                    setCountries(Country)
                }
            }).catch(err => {
                console.log(err)
            })
    }

    const ChangeClient = (i) => {
        setClientId(i);
        setNumber("1");
    }
    const delayedSearch = debounce((value) => {
        setSearchdebounce(value)
    }, 2000);

    const handleSearchChange = (e) => {
        const { value } = e.target;
        setSearch(value);
        delayedSearch(value);
    };
    useEffect(() => {
        if (Search === Searchdebounce) {
            setSpinner(true);
            if (clientId != "") {
                const ClayoBidding = ClaycoBiddingIntrestsListIds?.toString();
                const Bidding = BiddingIntrestsListIds?.toString();
                const Proficiency = ClientProfiencyCapabilitiesListIds?.toString();
                axios.get("AdminVendors/GetVendorsForInvite?pageNumber=" + number + "&pageSize=" + 12 + "&type=" + 1 + "&status=" + 0 + "&client=" + clientId + "&vendorName=" + Searchdebounce
                    + "&ERIOnly=" + Checked + "&state=" + stateid + "&Country=" + counrtyid + "&city=" + City + "&biddings=" + Bidding + "&proficiency=" + Proficiency
                    + "&claycoBiddings=" + ClayoBidding)
                    .then((res) => {
                        setMultiClient(res?.data?.data?.isMultiClient);
                        setVendorsForInviteList(res?.data?.data?.vendorData);
                        setBiddingIntrestsList(res?.data?.data?.biddingIntrests?.item2);
                        setClaycoBiddingIntrestsList(res?.data?.data?.claycoBiddingIntrests?.item2);
                        // setClientProfiencyCapabilitiesList(res?.data?.data?.clientProfiencyCapabilities?.item2);
                        let field = [];
                        for (let i = 0; i < res?.data?.data?.clientProfiencyCapabilities?.item2?.length; i++) {
                            field.push({ headding: res?.data?.data?.clientProfiencyCapabilities?.item2[i]?.key });
                            for (let j = 0; j < res?.data?.data?.clientProfiencyCapabilities?.item2[i]?.group?.length; j++) {
                                field.push({ text: res?.data?.data?.clientProfiencyCapabilities?.item2[i]?.group[j]?.value, value: res?.data?.data?.clientProfiencyCapabilities?.item2[i]?.group[j]?.key });
                            }
                        }
                        setClientProfiencyCapabilitiesList(field);
                        setCount(res?.data?.count);
                    }).catch(err => {
                        console.log(err);
                    }).finally(() => {
                        setTimeout(() => {
                            setSpinner(false);
                        }, 5000);
                    })
            }
        }
    }, [number, clientId, Search, Searchdebounce, Save]);

    const handlePageChange = (e) => {
        setNumber(e);
    };
    const SpinnerClose = () => {
        setSpinner(false);
    };
    const toggleDrawer = (open) => () => {
        setState(open);
    };
    const Clear = () => {
        //setState(false);
        setCounrtyid("");
        setStateid("");
        setStates([]);
        setCity("");
        setChecked(false);
        setBiddingIntrestsListIds([]);
        setClientProfiencyCapabilitiesListIds([]);
        setSave(!Save);
    }
    const ChangeProp = (e) => {
        setClientProfiencyCapabilitiesListIds(e);
    }

    return (
        <Box sx={{ width: "100%" }}>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Dialog
                fullScreen={fullScreen}
                open={dialogopen}
                onClose={DialogCloseClick}
            >
                <div style={{ marginLeft: "auto" }}>
                    <span className='mx-2' onClick={DialogCloseClick} style={{ color: "red", float: "right", cursor: "pointer" }}><CloseIcon /></span>
                </div>
                <OutsideNetworkEmailPage
                    DialogClose={DialogCloseClick}
                    ClientId={clientId}
                    INFO={Info}
                    To={To}
                    Body={Body}
                    VendorSummary={VendorSummary}
                    CCandBCCInfo={CCandBCCInfo}
                    LocationsList={LocationsList}
                    RisklevelList={RisklevelList}
                    VendorTypeListInfo={VendorTypeList}
                    SetBody={setBody}
                    SetTo={setTo}
                />
            </Dialog>

            <SwipeableDrawer
                anchor={"right"}
                open={state}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
            >
                <div>
                    <div style={{ padding: "10px" }}>
                        <Stack direction={"row"} spacing="Auto">
                            <span style={{ fontSize: "large", fontWeight: "bold" }}>Filters</span>
                            <Button color="error" onClick={() => setState(false)} sx={{ textTransform: "capitalize" }}><CloseIcon /></Button>
                        </Stack>
                        <Divider sx={{ marginTop: 2, backgroundColor: "#667085;", height: "2px" }} />
                    </div>
                    <div style={{ padding: "10px" }}>

                        <div className='mt-3' hidden={MultiClient == false}>
                            <span style={{ color: "#3E4A62" }}>Multi-Client Vendors Only</span>
                            <br />
                            <FormControlLabel
                                control={<Switch checked={Checked} onChange={(e) => setChecked(e?.target?.checked)} />}
                                label={Checked == true ? "Yes" : "No"}
                            />
                        </div>

                        <div className='mt-3' hidden={ClaycoBiddingIntrestsList == ""}>
                            <span style={{ color: "#3E4A62" }}>Clayco Bidding Interests</span>
                            <br />
                            <Select
                                labelId="docs-label"
                                id="docs-select"
                                multiple
                                size='small'
                                sx={{ width: "320px", overflow: "hidden" }}
                                name="Clayco Bidding Interests"
                                value={ClaycoBiddingIntrestsListIds || []}
                                MenuProps={MenuProps}
                                renderValue={(selected) =>
                                    selected
                                        .map((key) => ClaycoBiddingIntrestsList?.find((doc) => doc?.key === key)?.value)
                                        .filter((value) => value !== undefined)
                                        .join(", ")
                                }
                                onChange={(e) => setClaycoBiddingIntrestsListIds(e.target.value)}
                            >
                                {ClaycoBiddingIntrestsList?.map((r) => (
                                    <MenuItem key={r?.key} value={r?.key}>
                                        <Checkbox checked={ClaycoBiddingIntrestsListIds?.indexOf(r?.key) > -1} />
                                        <ListItemText primary={r?.value} />

                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                        <div className='mt-3' hidden={BiddingIntrestsList == ""}>
                            <span style={{ color: "#3E4A62" }}>Bidding Interests</span>
                            <br />
                            <Select
                                labelId="docs-label"
                                id="docs-select"
                                multiple
                                size='small'
                                sx={{ width: "320px", overflow: "hidden" }}
                                name="Bidding Interests"
                                value={BiddingIntrestsListIds || []}
                                MenuProps={MenuProps}
                                renderValue={(selected) =>
                                    selected
                                        .map((key) => BiddingIntrestsList?.find((doc) => doc?.key === key)?.value)
                                        .filter((value) => value !== undefined)
                                        .join(", ")
                                }
                                onChange={(e) => setBiddingIntrestsListIds(e.target.value)}
                            >
                                {BiddingIntrestsList?.map((r) => (
                                    <MenuItem key={r?.key} value={r?.key}>
                                        <Checkbox checked={BiddingIntrestsListIds?.indexOf(r?.key) > -1} />
                                        <ListItemText primary={r?.value} />

                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                        <div className='mt-3' hidden={ClientProfiencyCapabilitiesList == ""}>
                            <span style={{ color: "#3E4A62" }}>Proficiency & Capabilities</span>
                            <br />
                            <div style={{ width: "320px" }}>
                                <FormControl
                                    inputType={"select"}
                                    multiple={true}
                                    items={ClientProfiencyCapabilitiesList}
                                    value={ClientProfiencyCapabilitiesListIds}
                                    handleChange={(val) => ChangeProp(val)}
                                    width={"110%"}
                                    heighlight={"false"}
                                    propwidth={true}
                                />
                            </div>
                        </div>
                        <div className='mt-3' >
                            <span style={{ color: "#3E4A62" }}>Country</span>
                            <br />
                            {/* <FormControl
                                inputType="select"
                                items={countries.map(optionsDataMapper)}
                                value={counrtyid}
                                handleChange={getState}
                                width={"100%"}
                            /> */}
                            <Select
                                sx={{
                                    '& legend': { display: 'none' },
                                    '& fieldset': { top: 0 },
                                    width: "320px",
                                }}
                                labelId="counrty"
                                value={counrtyid || ""}
                                id="counrty"
                                size="small"
                                MenuProps={MenuProps}
                                onChange={(e) => getState(e.target.value)}
                            >
                                {countries?.map((item, index) => (
                                    <MenuItem key={index} value={item.value}>
                                        {item.value}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                        <div className='mt-3' >
                            <span style={{ color: "#3E4A62" }}>State</span>
                            <br />
                            <Select
                                sx={{
                                    '& legend': { display: 'none' },
                                    '& fieldset': { top: 0 },
                                    width: "320px",
                                }}
                                labelId="state"
                                id="state"
                                size="small"
                                value={stateid || ""}
                                MenuProps={MenuProps}
                                onChange={(e) => setStateid(e.target.value)}
                            >
                                {states?.map((item, index) => (
                                    <MenuItem key={index} value={item.value}>
                                        {item.value}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>
                        <div className='mt-3' >
                            <span style={{ color: "#3E4A62" }}>City</span>
                            <br />
                            <TextField
                                sx={{
                                    '& legend': { display: 'none' },
                                    '& fieldset': { top: 0 },
                                    width: "320px",
                                }}
                                id="City"
                                name="City"
                                placeholder="City"
                                size='small'
                                value={City || ""}
                                onChange={(e) => setCity(e.target.value)}
                            />
                        </div>

                        <div className='mt-2'>
                            <hr />
                            <Button variant="contained" className="login-help-button-cancel mx-2" sx={{ textTransform: "capitalize" }} onClick={Clear}> Clear Filters</Button>
                            <Button variant="contained" className="mx-2  mt-2" sx={{ padding: "20px", width: "140px", textTransform: "capitalize" }} onClick={() => {
                                setSave(!Save)
                                setState(false);
                            }}> Apply Filters</Button>
                        </div>
                    </div >


                </div>
            </SwipeableDrawer>

            <Card>
                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <span style={{ color: "red" }}>This tab is for inviting vendors that are not registered for your company, but are registered for other FIRST, VERIFY clients. You can filter your search by Bidding Interest, Proficiency & Capabilities (for utility companies), city and state. Click on the company name to view details and invite.</span>
                </div>
                <Divider sx={{ marginTop: 2, backgroundColor: "#667085;", height: "2px" }} />
                <div style={{ marginLeft: "10px", padding: "15px" }}>
                    <Stack spacing={2} direction="row">
                        <div>
                            <TextField
                                placeholder='Search'
                                sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                    fontFamily: "Arial, FontAwesome"
                                }}
                                variant="outlined"
                                size="small"
                                value={Search || ""}
                                onChange={handleSearchChange}
                            />
                        </div>
                        <div style={{ marginLeft: "Auto", }}>
                            <Select
                                sx={{
                                    '& legend': { display: 'none' },
                                    '& fieldset': { top: 0 },
                                    width: "320px"
                                }}
                                labelId="demo-multiple-name-label"
                                value={clientId || ""}
                                id="demo-multiple-name"
                                size="small"
                                onChange={(e) => ChangeClient(e.target.value, "")}
                                MenuProps={MenuProps}
                            >
                                {clientList?.map((r, i) =>
                                    <MenuItem key={i} title={r?.text} value={r?.value} > {r?.text}</MenuItem>
                                )}
                            </Select>
                        </div>
                        <div >
                            <Button variant="outlined" sx={{ padding: "15px" }} onClick={toggleDrawer(true)} >Filters</Button>
                        </div>
                    </Stack >
                </div>
                <Box sx={{ backgroundColor: '#f8f9fa' }}>
                    <>
                        {VendorsForInviteList?.length < 1 ?
                            <div hidden={spinner}>
                                <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 2, marginRight: "13px", width: "100%" }} className="text-center">
                                    <span style={{ color: "#667085" }}>No Records found</span>
                                </Box>
                            </div> :
                            <>
                                <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
                                    <Table aria-label="customized table">

                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Name</span></StyledTableCell>
                                                <StyledTableCell >&nbsp;</StyledTableCell>

                                            </TableRow>
                                        </TableHead>


                                        {VendorsForInviteList?.map((r, i) => (
                                            <TableBody key={i}>

                                                <TableRow key={i}>

                                                    <StyledTableCell sx={{ width: "30%" }}>
                                                        {r?.orgName}
                                                    </StyledTableCell>

                                                    <StyledTableCell sx={{ width: "5%" }} >
                                                        <span style={{ color: "#2A93DB", cursor: "pointer" }} onClick={() => DialogOpenClick(r)}> <MailOutlineIcon /> {"Invite Vendor"}</span>
                                                    </StyledTableCell>
                                                </TableRow>

                                            </TableBody>
                                        ))}
                                    </Table>

                                </TableContainer>
                            </>
                        }
                    </>
                </Box >

            </Card>
            <div hidden={Count < 1}>
                <Paginator
                    count={Math.ceil(Count / 12)}
                    page={Number(number)}
                    margin="18px 0px"
                    onChange={handlePageChange}
                />
            </div>


        </Box >
    );
}





